<template>
	<ClientOnly>
		<div
			v-if="ad"
			ref="adRoot"
			class="ad-buttler-ribbon-outer-wrapper"
		>
			<div
				class="ad-buttler-ribbon-container w-full"
				:class="{ 'has-sidebar': hasSidebar }"
			>
				<div class="xl:container">
					<p class="text-lg text-center">
						{{ body }}
					<a
						:href="trackingLink"
						target="_blank"
						rel="noopener noreferrer"
						class="font-semibold underline"
						@click.passive="onAdClick"
					>
							{{ cta }}
						</a>
					</p>
				</div>
			</div>

			<button
				class="adbutler-ribbon-button-close"
				@click="$emit('close')"
			>
				<img
					src="/images/close_dark_blue.svg"
					alt="close button ad ribbon"
					class="w-[20px] h-[20px]"
				/>
			</button>
		</div>
	</ClientOnly>
</template>

<script setup>
defineProps({
	hasSidebar: {
		type: Boolean,
		default: false
	}
});

defineEmits(["close"]);

const AIZEN_BASE_URL = "https://aizen-ad-manager.up.railway.app";
const SLOT_ID = "75cf42f2-6065-4bf2-8df6-168d8c7d9551";

const ad = useState(`aizen-ad-${SLOT_ID}`, () => null);
const adLoading = useState(`aizen-ad-loading-${SLOT_ID}`, () => false);
const impressionTracked = useState(`aizen-ad-impression-${SLOT_ID}`, () => false);

const adRoot = ref(null);

const normalizeAizenUrl = (url) => {
	if (!url) {
		return null;
	}
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}
	return `${AIZEN_BASE_URL}${url}`;
};

const { pageKey } = usePageKey()
const adCtx = computed(() => ({ pageKey: pageKey.value, surface: "banner" }))
const trackingLink = computed(() =>
	buildAdClickUrl(
		normalizeAizenUrl(ad.value?.clickUrl) || ad.value?.destinationUrl || "#",
		adCtx.value
	)
);
const onAdClick = () => fireAdClickEvent(adCtx.value)

const body = computed(() => {
	const properties = ad.value?.properties || {};
	return properties.body || properties.Body || "";
});

const cta = computed(() => {
	const properties = ad.value?.properties || {};
	return properties.cta_label || properties.cta || properties.CTA || "";
});

useAizenImpression(
	adRoot,
	() => normalizeAizenUrl(ad.value?.impressionUrl),
	{ firedRef: impressionTracked }
);

const fetchAd = async () => {
	if (ad.value || adLoading.value) {
		return;
	}

	adLoading.value = true;
	try {
		const response = await $fetch(`${AIZEN_BASE_URL}/api/slots/${SLOT_ID}/serve`);

		if (response?.clickUrl || response?.destinationUrl) {
			ad.value = response;
		}
	} catch {} finally {
		adLoading.value = false;
	}
};

const scheduleFetch = () => {
	const load = () => {
		fetchAd();
	};

	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(load, { timeout: 2000 });
		return;
	}

	window.setTimeout(load, 0);
};

onMounted(() => {
	if (process.client) {
		scheduleFetch();
	}
});
</script>
